import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import Directories from "../components/Home/Directories";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import Modal from "../components/Home/Modal";
import BaseLayout from "../components/global/BaseLayout";
import CounterUp from "../components/global/CounterUp";
import ServicesHome from "../components/Services/ContentServices";
import HeroSection from "../components/Home/HeroSection";
import ValuesOne from "../components/values/Values_2";
import Paletacolor from "../components/global/Paletacolor";
import BlockSeven from "../components/block/BlockSeven";
import BlockFive from "../components/block/BlockFive";
import BlockSix from "../components/block/BlockSix"
import VideoPromocional from "../components/global/VideoPromocional";

// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">

        <Modal />

        <HeroSection />
        <BlockSix
          sloganPrincipal={true}
          text={rpdata?.dbHome?.[0]?.text}
          image1={rpdata?.stock?.[0]}
          image2={rpdata?.stock?.[4]}
          image3={rpdata?.stock?.[5]}
          image4={rpdata?.stock?.[2]}
          listsServices={true}
        />

        

        {/* video promocional */}
        {
          rpdata?.videosPromo?.[0]?.activo ?
            <VideoPromocional
              title={rpdata?.dbSlogan?.[5]?.slogan}
              text={rpdata?.dbAbout?.[1]?.text}
              linkVideo={`${rpdata?.videosPromo?.[0].link}`}
              image={rpdata?.stock?.[1]}
            />
            : null
        }
        <Directories/>
        <BlockSeven
          title={rpdata?.dbSlogan?.[5]?.slogan}
          text={rpdata?.dbHome?.[1]?.text}
          image1={rpdata?.stock?.[3]}
        />

        <CounterUp image={rpdata?.stock?.[6]} />
        <ValuesOne image={rpdata?.stock?.[4]} />

        <BlockFive
            title={'A little about us'}
            text={rpdata?.dbAbout?.[0]?.text}
            image={rpdata?.stock?.[2]}
            listsAbout={true}
          />

        <ServicesHome />

        {/* Paleta de Colores */}

        {
          rpdata?.brandingExtra?.[0]?.activo ?
            <Paletacolor />
            : null
        }
        <div
          className="bgFormHome"
          style={{ backgroundImage: `url("${rpdata?.stock?.[0]}")` }}
        >
          <div className="relative">
            <FormHome />
          </div>
        </div>

        <Map />

      </div>
    </BaseLayout>
  );
}

export default Home;
